import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';
import { configuratorOptions, configuratorChoices, configuratorOptionIdSelector } from '../configurator';
import { currentActiveSkuSelector } from '../selections/index';

export const skuDataSelector = createSelector(
  (state) => state.skuData,
  (skuData) => skuData
);

export const selectSelectedSkuData = createSelector(
  [skuDataSelector, currentActiveSkuSelector],
  (skuData, selectedSkuId) => skuData[selectedSkuId] || {}
);

export const carpetByChoiceIdAndSkuSelector = createSelector(
  [skuDataSelector, configuratorOptionIdSelector('ColorFinish')],
  (skuData, optionId) => {
    if (optionId) {
      const carpetChoicesByIdAndSku = Object.entries(skuData).map((skuOptionData) => {
        const sku = skuOptionData[0];
        const { optionChoices } = skuOptionData[1];
        const carpetChoice = optionChoices.filter((optChoice) => optChoice.optionId === optionId);
        if (!isEmpty(carpetChoice)) {
          const { choiceId } = carpetChoice[0];
          return { choiceId, sku };
        }
        return null;
      });
      return carpetChoicesByIdAndSku;
    }
    return [];
  }
);

export const getSkuMatchedChoicesSelector = createSelector(
  [configuratorChoices, carpetByChoiceIdAndSkuSelector],
  (allChoices, choicesWithSkus) => {
    return choicesWithSkus.map((choiceWithSku) => allChoices[choiceWithSku.choiceId]);
  }
);

export const findConfiguratorChoiceBySkuSelector = (omsid) => createSelector(
  [skuDataSelector, configuratorOptionIdSelector('ColorFinish')],
  (skuData, optionId) => {
    if (optionId) {
      const foundOption = skuData[omsid].optionChoices.filter((opt) => opt.optionId === optionId);
      return foundOption[0];
    }
    return {};
  }
);

export const selectOptionsAndChoicesByOmsId = (omsid) => createSelector(
  [skuDataSelector, configuratorChoices, configuratorOptions],
  (skuData, configChoices, configOptions) => {
    return keyBy(skuData[omsid].optionChoices.map((optionAndChoice) => {
      const { optionId, choiceId } = optionAndChoice;
      return {
        optionId,
        choiceId,
        choiceValue: configChoices[choiceId].value,
      };
    }), 'optionId');
  }
);
